import React, { useCallback, useRef } from 'react';

import Button from '@prisjakt/ui-button';
import { Floater, Alignment } from '@prisjakt/ui/floater';
import { NudgeUp } from '@prisjakt/ui/hideable/variants';

import * as S from './styles';
import { IconChevronDown, IconChevronUp } from '@prisjakt/ui/icon';

type Props = {
  children: React.ReactNode;
  count?: number;
  dataTestType?: string;
  dataTestProperty?: string;
  disabled?: boolean;
  id: string;
  isOpen: boolean;
  onFilterToggle: (id: string) => void;
  outlined?: boolean;
  title: string;
};

export const FilterFloater = (props: Props) => {
  const {
    children,
    count,
    dataTestType,
    dataTestProperty,
    disabled = false,
    id,
    isOpen,
    onFilterToggle,
    outlined = false,
    title,
  } = props;

  const filterRef = useRef<HTMLDivElement>(null);

  const onClickHandler = useCallback(
    () => typeof onFilterToggle === 'function' && onFilterToggle(id),
    [onFilterToggle, id]
  );

  return (
    <S.FilterWrapper
      ref={filterRef}
      data-test="FeaturedFilter"
      data-test-type={dataTestType}
      data-test-property={dataTestProperty}
    >
      <Button
        size="small"
        color={outlined && !count ? 'quarternary' : 'primary'}
        data-test="FeaturedFilterButton"
        variant={outlined ? 'outlined' : 'text'}
        active={Boolean(isOpen)}
        icon={isOpen ? <IconChevronUp /> : <IconChevronDown />}
        iconPosition="right"
        onClick={onClickHandler}
        disabled={Boolean(disabled)}
      >
        <S.FilterButtonText>
          {count && count > 0 ? `${title} (${count})` : title}
        </S.FilterButtonText>
      </Button>

      <Floater
        horizontalAlign={Alignment.Start}
        verticalAlign={Alignment.EndOutside}
        zIndex={10}
      >
        <NudgeUp visible={isOpen}>
          <S.FilterPopup>
            <S.FilterContent>
              <S.Content>{children}</S.Content>
            </S.FilterContent>
          </S.FilterPopup>
        </NudgeUp>
      </Floater>
    </S.FilterWrapper>
  );
};
